var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { AvatarContext } from '../../avatar';
import { AvatarBlock } from '../../avatar-block';
import { usePageContext } from '../page-context';
import { RowLayout } from '../../row-layout';
import { styled } from '../../styled';
import { useMergedClasses } from '../../styles/classes';
import { Text } from '../../text';
import { StackLayout, StackLayoutItem } from '../../stack-layout';
import { getPageHeaderUtilityClass, pageHeaderClasses, pageHeaderComponentName, } from './page-header-classes';
import clsx from '../../utils/clsx';
var Root = styled(RowLayout, { name: pageHeaderComponentName, slot: 'Root' })(function (_a) {
    var _b, _c;
    var theme = _a.theme, ownerState = _a.ownerState;
    return (__assign(__assign(__assign({}, (ownerState.fullWidth && {
        paddingTop: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    })), (_b = {}, _b["& .".concat(pageHeaderClasses.title)] = __assign({}, theme.tokens.type_preset_page_title), _b)), (ownerState.compact && (_c = {
            padding: theme.spacing(2, 3),
            borderBottom: "1px solid ".concat(theme.tokens.color_border_default)
        },
        _c["& .".concat(pageHeaderClasses.title)] = __assign({}, theme.tokens.type_preset_page_title_compact),
        _c))));
});
export var Actions = styled('div', {
    name: pageHeaderComponentName,
    slot: 'Actions',
})(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
    });
});
var StyledStackLayout = styled(StackLayout, { name: pageHeaderComponentName, slot: 'StackLayout' })(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return ({
        alignItems: 'center',
        gap: ownerState.compact ? theme.spacing(2) : theme.spacing(0),
    });
});
export var PageHeader = React.forwardRef(function (props, ref) {
    var _a = usePageContext(), fullWidthContext = _a.fullWidth, compactContext = _a.compact;
    var breadcrumbs = props.breadcrumbs, startActions = props.startActions, className = props.className, fullWidthProp = props.fullWidth, compactProp = props.compact, title = props.title, _b = props.titleTypographyProps, titleTypographyProps = _b === void 0 ? {} : _b, description = props.description, _c = props.descriptionTypographyProps, descriptionTypographyProps = _c === void 0 ? {} : _c, metadata = props.metadata, _d = props.metadataTypographyProps, metadataTypographyProps = _d === void 0 ? {} : _d, actions = props.actions, avatar = props.avatar, children = props.children, rootProps = __rest(props, ["breadcrumbs", "startActions", "className", "fullWidth", "compact", "title", "titleTypographyProps", "description", "descriptionTypographyProps", "metadata", "metadataTypographyProps", "actions", "avatar", "children"]);
    var classes = useMergedClasses(pageHeaderClasses, getPageHeaderUtilityClass, props.classes);
    var fullWidth = fullWidthProp || fullWidthContext;
    var compact = compactProp || compactContext;
    return (React.createElement(Root, __assign({ className: clsx(classes.root, className), gutter: 2 }, rootProps, { ownerState: { fullWidth: fullWidth, compact: compact }, ref: ref }),
        breadcrumbs,
        React.createElement(StyledStackLayout, { className: classes.content, gutter: 4, ownerState: { compact: compact } },
            React.createElement(StackLayoutItem, { sx: { alignSelf: 'baseline' } }, startActions),
            React.createElement(StackLayoutItem, { sx: { flex: 1 } },
                React.createElement(AvatarBlock, { size: compact ? 'medium' : 'large', classes: {
                        root: classes.avatarBlock,
                        avatar: classes.avatar,
                    }, avatar: avatar && React.createElement(AvatarContext.Provider, { value: { size: 'large' } }, avatar), titleTypographyProps: __assign({ variant: compact ? 'h5' : 'h3', component: 'h1', className: classes.title }, titleTypographyProps), title: title, description: metadata, descriptionTypographyProps: __assign({ component: 'div', className: classes.metadata }, metadataTypographyProps), TitleBlockProps: { gutter: 0.5 }, endAdornment: !!actions && (React.createElement(Actions, { className: classes.actions, sx: { flex: 'none' } }, actions)) }))),
        !!description && (React.createElement(Text, __assign({ variant: "body2", color: "textSecondary", component: "p", className: classes.description }, descriptionTypographyProps), description))));
});
